import format from "date-fns/format";

import { Calendar } from "@livechat/design-system-icons";

import { CustomDateRangeFilterId, Filter, IDateRangeFilter } from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const labelsMap = {
  [CustomDateRangeFilterId.Today]: "Solved today",
  [CustomDateRangeFilterId.Yesterday]: "Solved yesterday",
  [CustomDateRangeFilterId.Last7Days]: "Solved in last 7 days",
  [CustomDateRangeFilterId.LastMonth]: "Solved last month",
};

export const resolutionDateRangeFilterConfig: IFilterConfig = {
  title: "Resolution date",
  multiple: false,
  icon: Calendar,
  getFilterLabelValues: (filterValues: IDateRangeFilter): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    const label =
      // @ts-expect-error TS(7053)
      labelsMap[filterValues.id] ||
      // @ts-expect-error TS(2345)
      `Solved: ${format(filterValues.from, "YYYY-MM-DD")} – ${format(filterValues.to, "YYYY-MM-DD")}`;

    return [
      {
        key: Filter.ResolutionDateRange,
        label,
      },
    ];
  },
};
